import { z } from "zod";
import { eventOccasionIdSchema } from "./eventOccasion.schemas";

export const eventOccurrenceIdSchema = z.coerce.number().int().positive();

export const eventOccurrenceSchema = z
	.object({
		eventOccurrenceId: eventOccurrenceIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		eventOccasionId: eventOccasionIdSchema,
		parentOccurrenceId: eventOccurrenceIdSchema.nullable(),
		startAt: z.coerce.date(),
		endAt: z.coerce.date(),
		timezone: z.string().min(1).max(64).default("Asia/Tokyo"),
		maxAttendees: z.coerce.number().int().positive(),
		minAttendees: z.coerce.number().int().min(0).default(0),
		bufferWaitlistSize: z.coerce.number().int().min(0).default(0),
		currentExpectedCount: z.coerce.number().int().min(0).default(0),
		currentConfirmedCount: z.coerce.number().int().min(0).default(0),
		isDisplayed: z.boolean().default(true),
		allowOnsitePayment: z.boolean().default(true),
		registrationClosesMinutesBefore: z.coerce.number().int().min(0).default(0),
		attendanceBarcodePrefix: z.string().max(32).nullable(),
		remarks: z.string().nullable().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
		deletedAt: z.coerce.date().nullable().optional(),
		eligibility: z
			.object({
				isBooked: z.boolean(),
				isConcurrentConflict: z.boolean(),
				isOverlapConflict: z.boolean(),
				isDeadlinePassed: z.boolean(),
			})
			.optional(),
	})
	.strict();

export const createEventOccurrenceSchema = eventOccurrenceSchema
	.omit({
		eventOccurrenceId: true,
		currentExpectedCount: true,
		currentConfirmedCount: true,
		createdAt: true,
		updatedAt: true,
		deletedAt: true,
	})
	.extend({
		tenantId: z.coerce.number().int().positive().optional(),
	});

export const updateEventOccurrenceSchema = createEventOccurrenceSchema.partial({
	eventOccasionId: true,
	parentOccurrenceId: true,
	startAt: true,
	endAt: true,
	timezone: true,
	maxAttendees: true,
	minAttendees: true,
	bufferWaitlistSize: true,
	isDisplayed: true,
	allowOnsitePayment: true,
	registrationClosesMinutesBefore: true,
	attendanceBarcodePrefix: true,
});
